export default "__VITE_ASSET__B$nhtenc__"